// Central registry for module-level caches used to prevent skeleton flash on re-mount.
// Components register cleanup callbacks; context calls clearAll() on logout.

const cleanups: (() => void)[] = [];

export function registerCacheCleanup(fn: () => void): void {
  cleanups.push(fn);
}

export function clearModuleCaches(): void {
  for (const fn of cleanups) fn();
}

// Shallow JSON comparison — avoids unnecessary re-renders when background fetch
// returns the same data that's already displayed.
export function hasChanged<T>(prev: T | null, next: T): boolean {
  if (prev === null) return true;
  return JSON.stringify(prev) !== JSON.stringify(next);
}

// Call after any contact/interaction mutation to ensure next page visit fetches fresh data.
// Clears both module-level caches (instant) and IDB cache keys that are now stale (async).
export async function invalidateAfterMutation(): Promise<void> {
  clearModuleCaches();
  try {
    const { deleteCached } = await import('./offlineStore');
    await Promise.all([
      deleteCached('dashboard'),
      deleteCached('activity'),
      deleteCached('reminders'),
      deleteCached('contacts:list'),
      deleteCached('interactions:list'),
    ]);
  } catch {
    // IDB failure is non-critical
  }
}
